export default [
    {
        name: 'rsvp_web',
        description: 'RSVP Web View',
        //active: true,
        active: false,
    },
    {
        name: 'rsvp_pdf',
        description: 'RSVP PDF View',
       // active: false,
        active: true,
    },
    {
        name: 'feature_announcement',
        description: 'Feature Announcement',
        active: false,
    },
    {
        name: 'social_share',
        description: 'Social Share',
        active: true,
    },
];
